AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Views", "Log");

AoPS.Alcumus.Views.Log = (function (AlcVLog) {
	// Dependencies
	var Flyout = AoPS.Ui.Flyout;
	var Rogb = AoPS.Rogb;
	var AlcUtils = AoPS.Alcumus.Utils;
	var AlcUrl = AoPS.Alcumus.Url;
	var AlcVBase = AoPS.Alcumus.Views.Base;

	AlcVLog.MainPanel = AlcVBase.BaseView.extend({
		LOG_ENTRY_LIMIT: 25,

		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-log-panel");

			this.aops_panel = !!options.aops_panel;
			this.displayed_ids = [];

			this.model.requestLoad(function (ok, data) {
				// Using the usual collection events here results in a gazillion
				// rerenders. Custom controlling when it gets called to make it
				// happen just once.
				this.listenTo(this.model.get("logs"), "logs_loaded", function () {
					var result = this.generateLogRows();
					if (result) {
						this.render();
					}
				});

				this.generateLogRows({no_animation: true});
				this.render();
			}, this);

			this.renderLoading();
		},

		events: {
			click: "skipAnimation",
		},

		// Wipes the original log entries and regenerates them from scratch.
		// Returns whether any changes were made to the rows.
		generateLogRows: function (options) {
			options = options || {};
			var should_animate = !options.no_animation;

			var logs_coll = this.model.get("logs");
			var valid_logs_array = logs_coll.filter(function (model) {
				return model.isValid();
			});
			var new_ids = this.getNewIds(valid_logs_array, this.displayed_ids);

			if (new_ids.no_change) {
				return false;
			}

			// Force all current animations to finish.
			this.skipAnimation();

			// Don't animate if the log was empty
			if (!this.displayed_ids.length) {
				new_ids.add = [];
			}
			this.displayed_ids = new_ids.show;

			// Views to consider displaying as a flyout
			var flyout_views = [];

			this.clearLocation("@log_entries");
			// Iteration order is last-to-display iterated over first
			_.each(
				new_ids.show,
				function (id) {
					var model = logs_coll.get(id);
					var ViewClass = this.computeSubviewClass(model);
					var view_obj = new ViewClass({model: model});

					if (view_obj.shouldShow()) {
						this.addSubviewToLocation(view_obj, "@log_entries");
						if (_.contains(new_ids.add, id) && should_animate) {
							view_obj.$el.hide().addClass("alc-log-entry-animate-vis");
							flyout_views.push(view_obj);
						}
					}
				},
				this
			);

			// Need to process flyouts starting with first-to-display, so reverse.
			flyout_views.reverse();
			_.each(flyout_views, this.processFlyout, this);

			return true;
		},

		// Pass a rendered log entry view object that was just added at, check if a
		// flyout should also be generated, and generate it if so.
		processFlyout: function (view) {
			// Check if a flyout is needed.
			if (!view.model.isMe()) {
				return;
			} else if (!view.flyout_level) {
				return;
			} else if (view.flyout_level <= 1 && this.$el.css("display") !== "none") {
				return;
			}

			var html = view.$el
				.html()
				.replace("<br>", " ")
				.replace("alc-one-line", "");
			var description = view.model.get("data").description;
			if (description) {
				html += "<br>" + description;
			}
			Flyout.queue(html, {
				class: view.flyout_class,
				time: view.flyout_time,
				animation_time: 300,
			});
		},

		// Returns an object with keys:
		//   no_change : true if the new IDs to display are the same as the old.
		//   show : the array of IDs to show.
		//   add : an array of IDs that should be added with an animation when
		//     the list of log entries are updated.
		getNewIds: function (logs, before_ids) {
			var log_ids = _.pluck(logs, "id");
			log_ids = log_ids.slice(0, this.LOG_ENTRY_LIMIT);

			var int_ids = _.intersection(log_ids, before_ids);
			// Animate all IDs beginning the list up to the first one also in the original.
			var no_anim_index = int_ids.length
				? _.indexOf(log_ids, int_ids[0])
				: log_ids.length;
			return {
				no_change: log_ids.length === int_ids.length,
				show: log_ids,
				add: log_ids.slice(0, no_anim_index),
			};
		},

		computeSubviewClass: function (log_model) {
			return AlcVLog.Entry[log_model.get("type")] || AlcVLog.Entry.default_view;
		},

		getContext: function () {
			return {
				log_empty: !this.model.get("logs").length,
			};
		},

		postRender: function () {
			AlcVBase.buildScrollbar(this.$el, {fade: true});

			setTimeout(_.bind(this.doAnimation, this), 10);

			// Done here instead of template since top element is normally untouched
			// after the first render.
			if (this.aops_panel) {
				this.$el.removeClass("white-panel").addClass("aops-panel");
			}

			if (!AoPS.session.logged_in) {
				this.$el.hide();
			}

			this.updateHeightOnRender();
		},

		skipAnimation: function () {
			this.$(".alc-log-entry-animate-vis")
				.finish()
				.removeClass("alc-log-entry-animate-vis")
				.show();
		},

		doAnimation: function () {
			var next_entry = this.$(".alc-log-entry-animate-vis").last();
			if (!next_entry || !next_entry.length) {
				return;
			}

			next_entry.slideDown(600).removeClass("alc-log-entry-animate-vis").show();
			setTimeout(_.bind(this.doAnimation, this), 1000);
		},

		// The log panel should expand to fill the remainder of the side column,
		// with its own scrollbar in the case of overflow. Unfortunately the
		// side column's heights are too unpredictable for CSS to be able to do
		// this.

		// See ProblemDisplay for a more sophisticated use of this same idea.

		// Determine minimum height that .content should use and return it.
		computeHeight: function () {
			// If we're not in the DOM, this function will go wrong, so stop here.
			if (this.$("h1").outerHeight() <= 0) {
				return null;
			}

			var height = $(window).height();
			// Subtract out everything above the view...
			height -= this.$el.offset().top;
			// ... and everything below, which is just the footer.
			height -= $("#small-footer-wrapper").outerHeight();
			// Artifically put in a margin between this and the footer.
			height -= 10;
			// Now we have the height of the whole view. Subtract out the header to finish.
			height -= this.$("h1").outerHeight();
			// Subtract out the height of the internal ad displayed underneath
			height -= 425;
			// Whew.
			return Math.max(75, height);
		},

		// Update the height of .content.
		setHeight: function () {
			var height = this.computeHeight();
			if (height) {
				this.$(".aops-scroll-outer").css("height", height);
			}
		},

		// Helper for postRender
		updateHeightOnRender: function () {
			if (!this.setHeightBound) {
				// All uses of setHeight, bound to this view, need to be the same
				// function object so that we can use it with $.off. Store that function
				// object in the setHeightBound property of the view if not already made.
				this.setHeightBound = _.bind(this.setHeight, this);
				$(window).on("resize", this.setHeightBound);
			}

			// Try twice, in case we're not in the DOM yet.
			this.setHeightBound();
			setTimeout(this.setHeightBound, 10);
		},

		onClose: function () {
			AlcVBase.BaseView.prototype.onClose.apply(this);
			if (this.setHeightBound) {
				$(window).off("resize", this.setHeightBound);
			}
		},
	});

	// Definitions of view classes for individual entries
	// All stuffed in AlcVLog.Entry object

	// Special fields used for flyouts:
	// - flyout_level: when is flyout displayed. 2 = always, 1 = only if log
	//     is invisible, 0 = never. Defaults to 0.
	// - flyout_class: class to apply to the flyout (usually success or info), if any.
	// - flyout_time: time to display the flyout. Defaults to 5500.

	AlcVLog.Entry = {};

	AlcVLog.EntryBase = AlcVBase.BaseView.extend({
		flyout_level: 0,
		flyout_class: "",
		flyout_time: 5500,

		initialize: function (options) {
			this.log_type = this.model.get("type") || "default_view";
			this.setTemplateAndUseRootEl(
				"alc-tpl-log-entry-" + this.log_type.replace("_", "-")
			);

			this.listenTo(this.model, "change", this.render);
			this.render();
		},

		// Can override with extra logic
		shouldShow: function () {
			return true;
		},
	});

	AlcVLog.Entry.default_view = AlcVLog.EntryBase.extend({
		getContext: function () {
			return {
				event_time: this.model.getEventTime(),
				username: this.model.getShownUsername(),
				type: this.model.get("type"),
				data: JSON.stringify(this.model.get("data")),
			};
		},
	});

	AlcVLog.Entry.level = AlcVLog.EntryBase.extend({
		flyout_level: 1,
		flyout_class: "success",

		getContext: function () {
			var data = this.model.get("data");
			if (data.type === "subject") {
				return {
					user_id: this.model.getUserUrlId(),
					username: this.model.getShownUsername(),
					model_name: this.model.getSubject().get("name"),
					new_level: data.new_level,
				};
			} else if (data.type === "astat") {
				return {
					user_id: this.model.getUserUrlId(),
					username: this.model.getShownUsername(),
					model_name: this.model.getAstat().get("name"),
					new_level: data.new_level,
				};
			} else if (data.type === "overall") {
				return {
					user_id: this.model.getUserUrlId(),
					username: this.model.getShownUsername(),
					model_name: "Overall",
					new_level: data.new_level,
				};
			}
		},
	});

	AlcVLog.Entry.topic_status = AlcVLog.EntryBase.extend({
		flyout_level: 1,
		flyout_class: "success",

		getContext: function () {
			var model = this.model;
			var old_status = model.get("data").old_status;
			var new_status = model.get("data").new_status;
			var verbed;
			if (new_status === "mastered") {
				verbed = "mastered";
			} else if (old_status === "mastered" && new_status !== "mastered") {
				verbed = "unmastered";
			} else if (new_status === "passed") {
				verbed = "passed";
			} else if (old_status === "passed" && new_status !== "passed") {
				verbed = "unpassed";
			}
			return {
				user_id: model.getUserUrlId(),
				username: model.getShownUsername(),
				topic_name: model.getTopic().get("name"),
				subject_name: model.getTopic().get("subject").get("name"),
				verbed: verbed,
			};
		},
	});

	AlcVLog.Entry.problem_finished = AlcVLog.EntryBase.extend({
		getContext: function () {
			var data = this.model.get("data");
			var streak = data.streak;
			var subject_data = data.subjects;

			subject_data = _.map(
				subject_data,
				function (subject_node) {
					subject_node.caption = subject_node.name + ".";
					if (streak) {
						subject_node.caption +=
							" Bonus from " + streak + "-problem streak.";
					}
					return subject_node;
				},
				this
			);

			return {
				event_time: this.model.getEventTime(),
				result: data.result,
				subject_data: subject_data || [],
				trial_id: data.trial_id,
				problem_text_short: data.problem_text_short,
			};
		},

		postRender: function () {
			this.processMathJax();

			var data = this.model.get("data");
			this.$el.click(function () {
				Backbone.trigger(
					"alc_goto_url",
					AlcUrl.getUrl("report_trial", "me", data.trial_id)
				);
			});
		},
	});

	AlcVLog.Entry.quest_assigned = AlcVLog.EntryBase.extend({
		flyout_level: 2,
		flyout_class: "info",

		shouldShow: function () {
			var quest = this.model.getQuest();
			return quest && quest.get("is_assigned");
		},

		getContext: function () {
			var data = this.model.get("data");
			return {
				user_id: this.model.getUserUrlId(),
				username: this.model.getShownUsername(),
				quest_name: data.name,
				quest_description: data.description,
				badge_data: AlcUtils.getBadgeData(
					data.quest_id,
					data.level,
					data.is_achievement
				),
			};
		},
	});

	AlcVLog.Entry.quest_finished = AlcVLog.EntryBase.extend({
		flyout_level: 2,
		flyout_class: "success",

		getContext: function () {
			var data = this.model.get("data");
			var xp_bonus = parseInt(data.xp_bonus || 0, 10);
			return {
				user_id: this.model.getUserUrlId(),
				username: this.model.getShownUsername(),
				quest_name: data.name,
				quest_description: data.description,
				badge_data: AlcUtils.getBadgeData(
					data.quest_id,
					data.level,
					data.is_achievement
				),
				xp_bonus: xp_bonus,
				is_achievement: !!data.is_achievement,
				is_bad: xp_bonus <= 0,
			};
		},
	});

	AlcVLog.Entry.friend_status = AlcVLog.EntryBase.extend({
		getContext: function () {
			var model = this.model;
			var user = model.getUser();
			if (user) {
				return {
					user_id: model.getUserUrlId(),
					username: model.getShownUsername(),
					friend_id: user.id,
					friend_name:
						'<span data-hj-suppress="" data-hj-masked="">' +
						user.get("username") +
						"</span>",
					accepted: model.get("data").accepted,
				};
			} else {
				return {
					user_id: model.getUserUrlId(),
					username: model.getShownUsername(),
					friend_id: 0,
					friend_name: "UNKNOWN",
					accepted: model.get("data").accepted,
				};
			}
		},
	});

	// Base class containing a few helper functions for the two focus changing
	// log entries (focus_changed, class_nag).
	// Note that we can assume no special focus values except
	// possibly the class nag old focus.

	AlcVLog.EntryFocusBase = AlcVLog.EntryBase.extend({
		// Only keys that should be in an object passed to a changeFocus function.
		FOCUS_VALUE_KEYS: ["topic_id", "parent_id", "parent_type"],

		// Used for making progress bars.
		makeBar: function (focus_data, location) {
			if (!focus_data) {
				return;
			}
			// Special focus values don't get progress bars made
			if (!parseInt(focus_data.topic_id, 10)) {
				return;
			}

			var bar = new Rogb.TopicProgressBar({
				object_data: focus_data,
				use_inset: true,
				show_name: "none",
			});
			this.addSubviewToLocation(bar, location);
			return bar;
		},

		// Used for getContext
		extractParentData: function (data) {
			var models = this.model.getFocusAsModels(data);
			if (!models) {
				return;
			}

			var parent = models[1];

			if (!parent) {
				return null;
			}

			if (parent.model_type === "user") {
				return {
					model_type: "subject",
					name: "All subjects",
				};
			}

			return {
				model_type: parent.model_type,
				name: parent.get("name"),
			};
		},

		// Used for getContext
		extractTopicData: function (data) {
			var models = this.model.get("user").getFocusAsModels(data);
			if (!models) {
				return;
			}

			var topic = models[0];
			var parent = models[1];

			if (!topic) {
				return null;
			}

			if (topic.model_type !== "topic") {
				return {
					name: "All Topics",
					status: null,
					time_status: null,
				};
			}

			var time_status;
			if (parent && parent.getTopicTimeStatus) {
				time_status = parent.getTopicTimeStatus(topic.id);
			}

			return {
				name: data.name,
				status: data.status,
				time_status: time_status,
			};
		},

		// Used as event handler for selecting a focus
		onSetFocus: function (focus_data) {
			this.model.get("user").changeFocus(
				focus_data,
				function (ok, data) {
					if (!ok) {
						AlcVBase.showModalError(
							"Your focus was not set successfully.",
							data
						);
					}
				},
				{allow_filter: true}
			);
		},

		// Provide an alc-log-text div and the focus value it is associated with.
		// Any alc-topic-name elements inside will become links; clicking it
		// will set your focus to the given focus_data value.
		// TODO: this is quite the hack...
		turnTopicNameIntoButton: function (text_el, focus_data) {
			if (!focus_data) {
				return;
			}
			focus_data = _.pick(focus_data, this.FOCUS_VALUE_KEYS);
			var onTextElClick = _.bind(this.onSetFocus, this, focus_data);

			text_el.find(".alc-topic-name").each(function () {
				var new_el = $("<a></a>");
				new_el.addClass("alc-topic-name alc-pointer");
				new_el.text($(this).text());
				new_el.attr("title", "Click here to change your focus to this topic.");
				new_el.click(onTextElClick);
				$(this).replaceWith(new_el);
			});
		},
	});

	AlcVLog.Entry.focus_changed = AlcVLog.EntryFocusBase.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-log-entry-focus-changed");

			var data = this.model.get("data");
			this.makeBar(data.old_focus, "@old_progress_bar");
			if (this.model.isNewFocusDifferent()) {
				this.makeBar(data.new_focus, "@new_progress_bar");
			}

			this.listenTo(this.model, "change", this.render);
			this.render();
		},

		getContext: function () {
			var model = this.model;
			var user = model.get("user");
			var data = model.get("data");
			var old_models = user.getFocusAsModels(data.old_focus) || [];
			var new_models = user.getFocusAsModels(data.new_focus) || [];
			var old_parent = old_models[1];
			var new_parent = new_models[1];

			// True iff both old and new focus are both from the
			// current assignment of the same class.
			var is_same_assignment =
				new_parent.model_type === "class" &&
				new_parent === old_parent &&
				old_parent.getTopicTimeStatus(old_models[0].id) === 0 &&
				new_parent.getTopicTimeStatus(new_models[0].id) === 0;

			// Uses helper functions defined in the base class
			var context = {
				old_parent: this.extractParentData(data.old_focus),
				old_topic: this.extractTopicData(data.old_focus),
				new_parent: this.extractParentData(data.new_focus),
				new_topic: this.extractTopicData(data.new_focus),
				is_same_parent:
					old_parent && new_parent && old_parent.id === new_parent.id,
				is_same_assignment: is_same_assignment,
			};

			if (!model.isNewFocusDifferent()) {
				// Pretend no new focus was set if the new focus is the same as the old.
				context.new_topic = null;
				context.new_parent = null;
			}

			return context;
		},

		postRender: function () {
			if (!this.model.isValidFocusEntry()) {
				this.$el.hide();
			} else {
				this.$el.show();
			}

			var data = this.model.get("data");
			this.turnTopicNameIntoButton(
				this.$(".alc-old-focus-text"),
				data.old_focus
			);
			this.turnTopicNameIntoButton(
				this.$(".alc-new-focus-text"),
				data.new_focus
			);
		},
	});

	AlcVLog.Entry.class_nag = AlcVLog.EntryFocusBase.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-log-entry-class-nag");

			var data = this.model.get("data");
			this.makeBar(data.old_focus, "@old_progress_bar");
			this.makeBar(data.due_focus, "@due_progress_bar");
			this.makeBar(data.overdue_focus, "@overdue_progress_bar");

			this.listenTo(this.model, "change", this.render);
			this.render();
		},

		getContext: function () {
			var model = this.model;
			var user = model.get("user");
			var data = model.get("data");
			// All of these will be [topic, parent]. ([0] is topic, [1] is parent.)
			var old_models = user.getFocusAsModels(data.old_focus) || [];
			var due_models = user.getFocusAsModels(data.due_focus) || [];
			var overdue_models = user.getFocusAsModels(data.overdue_focus) || [];

			// Uses helper functions defined in the base class
			return {
				old_parent: this.extractParentData(data.old_focus, old_models[1]),
				old_topic: this.extractTopicData(
					data.old_focus,
					old_models[0],
					old_models[1]
				),
				due_parent: this.extractParentData(data.due_focus, due_models[1]),
				due_topic: this.extractTopicData(
					data.due_focus,
					due_models[0],
					due_models[1]
				),
				overdue_parent: this.extractParentData(
					data.overdue_focus,
					overdue_models[1]
				),
				overdue_topic: this.extractTopicData(
					data.overdue_focus,
					overdue_models[0],
					overdue_models[1]
				),
			};
		},

		postRender: function () {
			if (!this.model.isValidFocusEntry()) {
				this.$el.hide();
			} else {
				this.$el.show();
			}

			var data = this.model.get("data");
			this.turnTopicNameIntoButton(
				this.$(".alc-due-focus-text"),
				data.due_focus
			);
			this.turnTopicNameIntoButton(
				this.$(".alc-overdue-focus-text"),
				data.overdue_focus
			);
			this.turnTopicNameIntoButton(
				this.$(".alc-prev-focus-text"),
				data.old_focus
			);
		},
	});

	return AlcVLog;
})(AoPS.Alcumus.Views.Log);
